'use client';

import { ForwardedRef, forwardRef, useState } from 'react';
import { Button, IcAccept, Typography, theme } from '@bgzt/ui';

import { Action, Spacing } from '~/components';
import { FilterValue } from '~/apis/search';

import styles from './MultiSelection.module.css';

type Props = {
  onChange: (action: Action) => void;
  options: FilterValue[];
  values?: string[];
  filterKey: string;
  title: string;
};

export const MultiSelection = forwardRef(function CategoryList(
  { values = [], filterKey, title, options, onChange }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isFolded, setIsFolded] = useState(false);

  const showMoreButton = options.length > 5 && !isExpanded;

  const handleMultiSelectionClick = (value: string) => {
    const isSelected = values.includes(value);
    const result = isSelected ? values.filter((v) => v !== value) : [...values, value];

    onChange({ type: filterKey, payload: result.length ? result : null });
  };

  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.titleContainer}>
        <Typography variant="L7" color="gray-200">
          {title}
        </Typography>
        <Typography
          variant="L7"
          color="black"
          role="button"
          onClick={() => {
            setIsFolded((prev) => !prev);
          }}
        >
          {isFolded ? '펼치기' : '접기'}
        </Typography>
      </div>
      {!isFolded && (
        <>
          {(options.length <= 5 ? options : options.slice(0, isExpanded ? options.length : 5)).map(
            ({ value, count, name }) => {
              const isSelected = value ? values.includes(value) : false;
              return (
                <button
                  className={styles.menuButton}
                  key={value}
                  onClick={() => value && handleMultiSelectionClick(value)}
                >
                  <div className={styles.categoryMenuTextContainer}>
                    <Typography variant="L4" color="gray-900">
                      {name}
                    </Typography>
                    <Typography variant="L11" color="gray-200">
                      {count?.toLocaleString()}개
                    </Typography>
                  </div>

                  <IcAccept size={20} fill={isSelected ? theme.colors['red-500'] : theme.colors['gray-100']} />
                </button>
              );
            },
          )}
          {showMoreButton && (
            <>
              <Spacing height={10} />
              <Button
                className={styles.moreButton}
                variant="normalGray"
                size="large"
                onClick={() => {
                  setIsExpanded(true);
                }}
              >
                더보기
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );
});
